// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + {"255":"test","586":"reader","594":"about"}[chunkId] + "." + {"255":"7c25b900","586":"4112f144","594":"c1934cd1"}[chunkId] + ".js";
};